import { render, staticRenderFns } from "./table-budget-expend.vue?vue&type=template&id=3abe1951&scoped=true&"
import script from "./table-budget-expend.vue?vue&type=script&lang=ts&"
export * from "./table-budget-expend.vue?vue&type=script&lang=ts&"
import style0 from "./table-budget-expend.vue?vue&type=style&index=0&id=3abe1951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe1951",
  null
  
)

export default component.exports